import { useEffect, useState } from "react"
import { Modal, Table, Button } from "react-bootstrap"

import API from "components/Apis/API"
import { makeProNumber, makeNiceDate } from "components/Warehouse/helpers"

const getOrderHistory = async (orderHistory, setHistoryData) => {
  const url = "" + "admin/get_order_history"
  let formData = new FormData()
  formData.append("order_id", orderHistory.id)
  const responseData = await API.postData(url, formData)
  setHistoryData(responseData)
}

const UserHistoryModal = ({
  showUserHistory,
  setShowUserHistory,
  orderHistory,
}) => {
  const [historyData, setHistoryData] = useState([])
  const handleCloseModal = () => {
    setShowUserHistory(false)
  }
  useEffect(() => {
    if (showUserHistory) {
      getOrderHistory(orderHistory, setHistoryData)
    }
  }, [showUserHistory])
  return (
    <Modal
      className='old-orders-modal-old-history'
      show={showUserHistory}
      onHide={handleCloseModal}
    >
      <Modal.Header className='pt-0'>
        <Modal.Title>
          Order History for {makeProNumber(orderHistory)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='pt-0'>
        <Table striped borded hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Action</th>
              <th>Date</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            {historyData.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.message}</td>
                <td>{makeNiceDate(item.updated_at)}</td>
                <td>{item.username.split("@")[0]}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleCloseModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UserHistoryModal
